import React, { useEffect } from "react";
import styles from "./RecommendProduct.module.css";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchListProductRecommendRequest } from "redux/ActionCreators/ProductActionCreators";
import { Grid } from "@material-ui/core";
import CardItem from "components/Card/CardItem/CardItem";
import Title from "components/Title";
import toArrayImageFromImageRegex from "shared/func/toArrayImageFromImageRegex";

function RecommendProduct(props) {
  const { count } = props;
  const product = useSelector((state) => state.products.detail);
  const productsRecommend = useSelector(
    (state) => state.products.listRecommends
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (product) {
      dispatch(fetchListProductRecommendRequest(product.category.id, count));
    }
  }, [product]);

  if (!productsRecommend) return <div>Loading...</div>;
  return (
    <div className={styles.container}>
      <Title name={"GỢI Ý DÀNH CHO BẠN"} />

      <Grid container>
        {productsRecommend.map((item, index) => {
          return (
            <Grid item xs={12} sm={4} key={index}>
              <CardItem
                id={item.id}
                imgPath={toArrayImageFromImageRegex(item.imageRegex)[0]}
                title={item.name}
                price={item.price}
                priceDiscount={item.priceDiscount}
                discount={`${
                  100 - parseInt((item.priceDiscount / item.price) * 100)
                }%`}
                rating={item.rating}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

RecommendProduct.propTypes = {};

export default RecommendProduct;
